import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { VALUE_INPUTS_NAMES } from 'site-modules/shared/components/range/range';
import { PriceInput } from 'site-modules/lease-deals/components/price-input/price-input';

import './range-inputs-panel.scss';

export function RangeInputsPanel({
  hasTwoThumbs = false,
  maxValue,
  minValue,
  inputAddon = null,
  showLabels = false,
  disableInputs = false,
  minOutputText,
  onInputBlur,
  onInputChange,
  onInputFocus,
  onInputKeyDown,
  rangeName,
  className = '',
  min,
  max,
}) {
  const handleInputChange = useCallback(
    (_newValue, e) => {
      onInputChange(e);
    },
    [onInputChange]
  );

  return (
    <div className={classnames('d-flex align-items-center w-100', className)}>
      <div className="lease-deals-range-inputs-panel-input-wrapper">
        <PriceInput
          id={`${VALUE_INPUTS_NAMES.MIN}-${rangeName}`}
          startAdornment={inputAddon}
          inputMode="numeric"
          value={minValue}
          min={min}
          max={max}
          onChange={handleInputChange}
          onBlur={onInputBlur}
          onFocus={onInputFocus}
          onKeyDown={onInputKeyDown}
          disabled={disableInputs}
          name={VALUE_INPUTS_NAMES.MIN}
          labelText={showLabels ? 'Minimum' : undefined}
          aria-label={hasTwoThumbs ? `Min ${rangeName} value` : minOutputText}
        />
      </div>
      {hasTwoThumbs && (
        <Fragment>
          {showLabels && <span className="small mx-1 mt-1_25">to</span>}
          <div className="lease-deals-range-inputs-panel-input-wrapper">
            <PriceInput
              id={`${VALUE_INPUTS_NAMES.MAX}-${rangeName}`}
              startAdornment={inputAddon}
              inputMode="numeric"
              value={maxValue}
              min={min}
              max={max}
              onChange={handleInputChange}
              onBlur={onInputBlur}
              onFocus={onInputFocus}
              onKeyDown={onInputKeyDown}
              disabled={disableInputs}
              name={VALUE_INPUTS_NAMES.MAX}
              aria-label={`Max ${rangeName} value`}
              labelText={showLabels ? 'Maximum' : undefined}
            />
          </div>
        </Fragment>
      )}
    </div>
  );
}

RangeInputsPanel.propTypes = {
  minValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  maxValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  hasTwoThumbs: PropTypes.bool,
  showLabels: PropTypes.bool,
  inputAddon: PropTypes.element,
  disableInputs: PropTypes.bool,
  minOutputText: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rangeName: PropTypes.string.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onInputBlur: PropTypes.func.isRequired,
  onInputFocus: PropTypes.func.isRequired,
  onInputKeyDown: PropTypes.func.isRequired,
  className: PropTypes.string,
};
